<template>
  <div class="coffee my-bg scrollElement " style="margin-top: 100px; margin-bottom: 150px">
    <img src="/img/coffee1.png" class="w-100" alt="">
    <div class="row d-grid ">
      <div class="col-10 row align-self-center mx-auto flex-row-reverse">
        <div class="col-lg-5 d-grid">
          <img src="/img/make.png" class="img-fluid align-self-center" alt="">
        </div>
        <div class="col-lg-7 d-grid pb-3">
          <div class="align-self-end">
            <h3 class="text-center my-3">راهنمای دم آوری قهوه</h3>
            <p class="text-justify px-lg-5 mb-3">
              دم‌آوری قهوه فرآیند استخراج عطر و طعم از دانه‌های آسیاب‌شده قهوه با استفاده از آب داغ است. هدف این است که ترکیبات معطر و خوش‌طعم قهوه به‌طور متعادل استخراج شوند. در خانه، روش‌های مختلفی برای دم‌آوری قهوه وجود دارد که هر کدام طعمی خاص و متفاوت تولید می‌کنند.
              <br>

              <b class="d-block my-3">روش‌های معمول دم‌آوری قهوه در خانه:</b>
              <b class="d-block mt-2">فرنچ پرس (French Press):</b>
              قهوه و آب داغ را در یک ظرف استوانه‌ای ترکیب کرده و بعد از چند دقیقه با فشار دادن فیلتر، قهوه را جدا می‌کنید.
              مناسب برای قهوه‌ای با طعم غلیظ و بدون فیلتر کاغذی.
              <br>
              <b class="d-block mt-2">موکاپات (Moka Pot):</b>
              قهوه با استفاده از بخار آب در یک دستگاه روی گاز دم می‌شود.
              قهوه‌ای قوی مشابه اسپرسو تولید می‌کند.
              <br>
              <b class="d-block mt-2">اسپرسوساز خانگی:</b>
              با فشار دادن آب داغ از میان قهوه ریز آسیاب‌شده، اسپرسوی غلیظ و کرم‌دار تولید می‌کند.
              مناسب برای اسپرسو و انواع نوشیدنی‌های قهوه مثل کاپوچینو و لاته.
              <br>
              <b class="d-block mt-2">دریپ (Pour Over):</b>
              آب داغ به‌آرامی روی قهوه آسیاب‌شده ریخته می‌شود و از فیلتر عبور می‌کند.
              مناسب برای قهوه‌ای با طعم شفاف و ملایم.
            </p>
          </div>
        </div>
      </div>
    </div>
    <img src="/img/coffee2.png" class="w-100" alt="">

  </div>
</template>

<script>
export default {
  name: "Coffee"
}
</script>

<style scoped>

</style>